import { render } from "./VZKeyValue.vue?vue&type=template&id=56349138&scoped=true&ts=true"
import script from "./VZKeyValue.vue?vue&type=script&lang=ts"
export * from "./VZKeyValue.vue?vue&type=script&lang=ts"

import "./VZKeyValue.vue?vue&type=style&index=0&id=56349138&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56349138"]])

export default __exports__